import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Container, Button, Card, Form } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import { connect } from "react-redux";
import { find, isEmpty, isNull } from "lodash";
import "jspdf-autotable";
import Swal from "sweetalert";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import Select from "react-select";
import Typography from "@mui/material/Typography";
import EmailTwoToneIcon from "@mui/icons-material/EmailTwoTone";
import AddIcCallTwoToneIcon from "@mui/icons-material/AddIcCallTwoTone";
import NumbersTwoToneIcon from "@mui/icons-material/NumbersTwoTone";
import AddBusinessTwoToneIcon from "@mui/icons-material/AddBusinessTwoTone";
import AddLocationAltTwoToneIcon from "@mui/icons-material/AddLocationAltTwoTone";
import DomainTwoToneIcon from "@mui/icons-material/DomainTwoTone";
import DialpadTwoToneIcon from "@mui/icons-material/DialpadTwoTone";
import { phone } from "phone";
import { getCountry } from "../../country/Country.action";
import { addReceiver, getReceiver } from "../../receiver/Receiver.action";
import {
  setAddReceiverData,
  setEditableReceiver,
  setShowButtonReceiver,
  setShowShipmentDetail,
} from "./CreateShipment.action";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ReactSelect from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
const Step2SelectReceiver = (props) => {
  const [editable, setEditable] = useState(true);
  const [newOrOld, setNewOrOld] = useState(0);
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);
  const getReceiverList =
    !isEmpty(props.receiverList) &&
    props.receiverList.map((x) => {
      let data = {
        value: x.receiver_id,
        label: `${x.name} / ${x.company}`,
        email: x.email,
        phone: x.phone,
        postal_code: x.postal_code,
        country_id: x.country_id,
        country: x.country.name,
        address: x.address,
        address_2: x.address_2,
        address_3: x.address_3,
        city: x.city,
        state: x.state,
        company: x.company,
        __isNew__: false,
      };
      return data;
    });
  const handleVisible = (msg) => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  };

  const [emailError, setEmailError] = useState(false);
  const [companyError, setCompanyError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [addressError2, setAddressError2] = useState(false);
  const [cellNumberError, setCellNumberError] = useState(false);
  // const handleCellNumberChange = (e) => {

  //   let data= phone(e.target.value, {country: `${props.senderData[0].country_code}`});

  //    props.setReceiverData({ key: "phone", value: e.target.value });
  //    // const pattern =
  //    //   /^(?:\+92|0)?(3\d{2}|5[0-9]\d{1}|7[0-9]\d{1}|8[0-9]\d{1}|9[0-9]\d{1})\d{7}$/;
  //    // const inputValue = e.target.value;
  //    // if (e.target.value.length <= 11) {
  //    //   //   setPhone(inputValue);
  //    //   props.setSenderData({ key: "phone", value: inputValue });

  //      if (data.isValid==true) {
  //        setCellNumberError(false);
  //        // props.setSenderData({ key: "phone", value: props.senderData[0].phone });
  //      } else {
  //        setCellNumberError(true);
  //        // props.setSenderData({ key: "phone", value: e.target.value });
  //      }
  //    // }
  //  };
  const handleCellNumberChange = (e) => {
    let data = phone(e.target.value, {
      country: `${props.receiverData[0].country_code}`,
    });
    props.setReceiverData({ key: "phone", value: e.target.value });
    // const pattern =
    //   /^(?:\+92|0)?(3\d{2}|5[0-9]\d{1}|7[0-9]\d{1}|8[0-9]\d{1}|9[0-9]\d{1})\d{7}$/;
    // const inputValue = e.target.value;
    // if (e.target.value.length <= 11) {
    //   //   setPhone(inputValue);
    //   props.setSenderData({ key: "phone", value: inputValue });
    if (props.receiverData[0].country_code == "US") {
      if (e.target.value.length == 10) {
        setCellNumberError(false);
      } else {
        setCellNumberError(true);
      }
    } else {
      if (data.isValid == true) {
        setCellNumberError(false);
        // props.setSenderData({ key: "phone", value: props.senderData[0].phone });
      } else {
        setCellNumberError(true);
        // props.setSenderData({ key: "phone", value: e.target.value });
      }
    }
    // }
  };
  const handleAddressChange = (e) => {
    if (e.target.value.length < 45) {
      props.setReceiverData({
        key: "address",
        value: e.target.value.toUpperCase(),
      });
      setAddressError(false);
    } else {
      setAddressError(true);
    }
  };
  const handleAddress2Change = (e) => {
    if (e.target.value.length < 45) {
      props.setReceiverData({
        key: "address_2",
        value: e.target.value.toUpperCase(),
      });
      setAddressError2(false);
    } else {
      setAddressError2(true);
    }
  };
  const handleCompanyNameChange = (e) => {
    props.setReceiverData({
      key: "company",
      value: e.target.value.toUpperCase(),
    });
    if (e.target.value.length > 2) {
      setCompanyError(false);
    } else {
      setCompanyError(true);
    }
  };
  const handleEmailChange = (e) => {
    props.setReceiverData({ key: "email", value: e.target.value });
    if (e.target.validity.valid) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
  };
  const selectInputRef = useRef();
  const [testval, setTestVal] = useState(null);
  const onOptionsChanged = (e, f) => {
    // if (isNull(e)) { clearData() }
    // else{
    if (f.action == "clear") {
      //  f.preventDefault();
      //  selectInputRef.current.clearValue();
      setTestVal(null);
      clearData();
    }
    if (f.action == "select-option") {
      props.setEditableReceiver(false);
      props.setShowButtonReceiver(true);
      props.ownProps.moveToDetail();
      setTestVal({ label: e.label });
      props.setReceiverData({ key: "id", value: e.value });
      props.setReceiverData({ key: "key", value: true });
      props.setReceiverData({ key: "name", value: e.label.toUpperCase() });
      props.setReceiverData({ key: "country_id", value: e.country_id });
      props.setReceiverData({
        key: "country_name",
        value: e.country.toUpperCase(),
      });
      props.setReceiverData({ key: "company", value: e.company.toUpperCase() });
      props.setReceiverData({ key: "address", value: e.address.toUpperCase() });
      props.setReceiverData({
        key: "address_2",
        value: e.address_2.toUpperCase(),
      });
      props.setReceiverData({
        key: "address_3",
        value: e.address_3.toUpperCase(),
      });
      props.setReceiverData({
        key: "postal_code",
        value: e.postal_code.toUpperCase(),
      });
      props.setReceiverData({ key: "city", value: e.city.toUpperCase() });
      props.setReceiverData({ key: "state", value: e.state.toUpperCase() });
      props.setReceiverData({ key: "email", value: e.email });
      props.setReceiverData({ key: "phone", value: e.phone.toUpperCase() });
      props.setShowShipmentDetail(true);
    } else if (f.action == "create-option") {
      props.setShowShipmentDetail(false);
      props.setShowButtonReceiver(false);
      props.setReceiverData({ key: "key", value: false });
      props.setReceiverData({ key: "name", value: e.label.toUpperCase() });
      props.setReceiverData({ key: "id", value: "" });
      props.setEditableReceiver(false);
      setTestVal({ label: e.label });
      props.setReceiverData({ key: "country_id", value: "" });
      props.setReceiverData({ key: "country_name", value: "" });
      props.setReceiverData({ key: "company", value: "" });
      props.setReceiverData({ key: "address", value: "" });
      props.setReceiverData({ key: "address_2", value: "" });
      props.setReceiverData({ key: "address_3", value: "" });
      props.setReceiverData({ key: "postal_code", value: "" });
      props.setReceiverData({ key: "city", value: "" });
      props.setReceiverData({ key: "state", value: "" });
      props.setReceiverData({ key: "email", value: "" });
      props.setReceiverData({ key: "phone", value: "" });
    }
  };
  const handleChangeReceiverType = (e) => {
    setNewOrOld(e.target.value);
    e.target.value == 1
      ? props.setEditableReceiver(false)
      : props.setEditableReceiver(true);
    e.target.value == 1
      ? props.setShowButtonReceiver(false)
      : props.setShowButtonReceiver(true);
    clearData();
    // props.setShowButtonSender(false);
  };
  const selectOption = (e) => {
    // props.setEditable(false);
    // props.setShowButtonSender(true);
    props.ownProps.moveToDetail();
    // setTestVal({ label: e.label });
    props.setReceiverData({ key: "id", value: e.value });
    props.setReceiverData({ key: "key", value: true });
    props.setReceiverData({ key: "name", value: e.label.toUpperCase() });
    props.setReceiverData({ key: "country_id", value: e.country_id });
    props.setReceiverData({
      key: "country_name",
      value: e.country.toUpperCase(),
    });
    props.setReceiverData({ key: "company", value: e.company.toUpperCase() });
    props.setReceiverData({ key: "address", value: e.address.toUpperCase() });
    props.setReceiverData({
      key: "address_2",
      value: e.address_2.toUpperCase(),
    });
    props.setReceiverData({
      key: "address_3",
      value: e.address_3.toUpperCase(),
    });
    props.setReceiverData({
      key: "postal_code",
      value: e.postal_code.toUpperCase(),
    });
    props.setReceiverData({ key: "city", value: e.city.toUpperCase() });
    props.setReceiverData({ key: "state", value: e.state.toUpperCase() });
    props.setReceiverData({ key: "email", value: e.email });
    props.setReceiverData({ key: "phone", value: e.phone.toUpperCase() });
    props.setShowShipmentDetail(true);
  };
  const newReceiver = (e) => {
    props.setReceiverData({
      key: "name",
      value: e.target.value.toUpperCase(),
    });
  };

  const handleChangeCountry = (e) => {
    props.setReceiverData({ key: "country_id", value: e.value });
    props.setReceiverData({
      key: "country_name",
      value: e.label.toUpperCase(),
    });
    props.setReceiverData({ key: "country_code", value: e.country_code });
    props.setReceiverData({ key: "dial_code", value: e.dial_code });
    props.setReceiverData({ key: "phone", value: "" });
    // setCountry(e.target.value);
  };
  const handleContinue = () => {
    props.setShowShipmentDetail(true);
    props.ownProps.moveToDetail();
  };
  const handleSaveReceiver = () => {
    props.addReceiver(
      {
        name: props.receiverData[0].name,
        company: props.receiverData[0].company,
        country_id: props.receiverData[0].country_id,
        address: props.receiverData[0].address,
        address_2: props.receiverData[0].address_2,
        address_3: props.receiverData[0].address_3,
        postal_code: props.receiverData[0].postal_code,
        city: props.receiverData[0].city,
        state: props.receiverData[0].state,
        email: props.receiverData[0].email,
        phone: props.receiverData[0].phone,
      },
      handleVisible,
      handleDangerVisible
    );
    props.ownProps.moveToDetail();
    props.setShowShipmentDetail(true);
  };
  const clearData = () => {
    props.setReceiverData({ key: "name", value: "" });
    props.setReceiverData({ key: "country_id", value: 0 });
    props.setReceiverData({ key: "country_name", value: "" });
    props.setReceiverData({ key: "company", value: "" });
    props.setReceiverData({ key: "address", value: "" });
    props.setReceiverData({ key: "address_2", value: "" });
    props.setReceiverData({ key: "address_3", value: "" });
    props.setReceiverData({ key: "postal_code", value: "" });
    props.setReceiverData({ key: "city", value: "" });
    props.setReceiverData({ key: "state", value: "" });
    props.setReceiverData({ key: "email", value: "" });
    props.setReceiverData({ key: "phone", value: "" });
  };
  useEffect(() => {
    // props.getReceiver()
    // props.getCountry()
    clearData();
  }, []);
  const getCountryList =
    !isEmpty(props.countryList) &&
    props.countryList.map((x) => {
      let data = {
        value: x.country_id,
        label: x.name,
        country_code: x.code,
        dial_code: x.dial_code,
      };
      return data;
    });
  return (
    <>
      <Container fluid>
        {/* <div className="main"> */}
        <Card
          style={{
            borderRadius: "30px",
            boxShadow:
              " 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            border: "none",
            padding: "20px",
            marginTop: "20px",
            height: props.showButtonReceiver == false ? "55%" : "50%",
          }}
        >
          <Row>
            <Col xl="12" lg="12" md="12" sm="12" xs="12">
              <Typography style={{ fontFamily: "Public Sans,sans-serif" }}>
                <b>TO</b>
              </Typography>
            </Col>
          </Row>
          <Row style={{ marginTop: "15px" }}>
            {/* <Col xl="12" lg="12" md="12" sm="12" xs="12" style={{ zIndex: 10 }}>
              <CreatableSelect
                styles={{
                  control: (provided) => ({
                    ...provided,
                    border: "none",
                    borderBottom: "1px solid black",
                    borderRadius: 0,
                    boxShadow: "none",
                    backgroundColor: "white",
                  }),
                }}
                isClearable={true}
                backspaceRemovesValue={true}
                escapeClearsValue={true}
                ref={selectInputRef}
                value={testval}
                options={!isEmpty(getReceiverList) ? getReceiverList : []}
                onChange={onOptionsChanged}
              /> */}
            <Col xl="6" lg="6" md="6" sm="6" xs="12">
              <FormControl variant="standard" fullWidth>
                <InputLabel id="demo-simple-select-standard-label" required>
                  Select Receiver Type
                </InputLabel>
                <ReactSelect
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  // value={countryId}
                  value={newOrOld}
                  // label="Select Purpose"
                  onChange={handleChangeReceiverType}
                  // input={<OutlinedInput label="Select Purpose" />}
                >
                  <MenuItem key={1} value={1}>
                    New
                  </MenuItem>
                  <MenuItem key={2} value={2}>
                    From Contact
                  </MenuItem>
                </ReactSelect>
              </FormControl>
            </Col>
            {newOrOld == 0 || newOrOld == 2 ? (
              <Col xl="6" lg="6" md="6" sm="6" xs="12" style={{ zIndex: 10 }}>
                {/* <p style={{fontSize:'12px',marginBottom:'-8px'}}> */}
                <p
                  style={{
                    fontSize: "12px",
                    fontFamily: "Public Sans,sans-serif",
                    marginBottom: "-2px",
                    color: "#00000061",
                  }}
                >
                  SELECT RECEIVER*
                </p>
                <Select
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      border: "none",
                      borderBottom: "1px solid black",
                      borderRadius: 0,
                      boxShadow: "none",
                      backgroundColor: "white",
                      marginTop: "-1px",
                    }),
                  }}
                  isDisabled={isEmpty(getReceiverList) || newOrOld == 0}
                  value={{ label: props.receiverData[0].name }}
                  // placeholder="SELECT RECEIVER..."
                  onChange={selectOption}
                  options={!isEmpty(getReceiverList) ? getReceiverList : []}
                />
              </Col>
            ) : (
              <Col xl="6" lg="6" md="6" sm="6" xs="12">
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <DomainTwoToneIcon />
                      </InputAdornment>
                    ),
                  }}
                  required
                  type="text"
                  id="standard-basic"
                  variant="standard"
                  label="Receiver Name"
                  // error={companyError}
                  // helperText={
                  //   companyError
                  //     ? "Please Enter Your Company Name (Atleast 3 Character)"
                  //     : ""
                  // }
                  value={props.receiverData[0].name}
                  // disabled={props.editSender}
                  onChange={(e) => newReceiver(e)}
                  sx={{
                    width: "100%",
                    textTransform: "uppercase",
                  }}
                />
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: "15px" }}>
            <Col xl="4" lg="4" md="4" sm="4" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DomainTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                required
                type="text"
                id="standard-basic"
                variant="standard"
                label="Company"
                value={props.receiverData[0].company}
                disabled={props.editReceiver}
                error={companyError}
                helperText={
                  companyError
                    ? "Please Enter Your Company Name (Atleast 3 Character)"
                    : ""
                }
                onChange={(e) => handleCompanyNameChange(e)}
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
            <Col xl="4" lg="4" md="4" sm="4" xs="12" style={{ zIndex: 8 }}>
              <p
                style={{
                  fontSize: "12px",
                  fontFamily: "Public Sans,sans-serif",
                  marginBottom: "-2px",
                  color: "#00000061",
                }}
              >
                SELECT COUNTRY*
              </p>
              <Select
                styles={{
                  control: (provided) => ({
                    ...provided,
                    border: "none",
                    borderBottom: "1px solid black",
                    borderRadius: 0,
                    boxShadow: "none",
                    backgroundColor: "white",
                    marginTop: "-1px",
                  }),
                }}
                isDisabled={isEmpty(props.countryList) || props.editReceiver}
                value={{ label: props.receiverData[0].country_name }}
                isOptionDisabled={(option) =>
                  option.value == props.senderData[0].country_id
                }
                placeholder="SELECT COUNTRY..."
                onChange={handleChangeCountry}
                options={getCountryList}
              />
              {/* </FormControl> */}
            </Col>
            <Col xl="4" lg="4" md="4" sm="4" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AddIcCallTwoToneIcon />
                      {props.receiverData[0].dial_code}
                    </InputAdornment>
                  ),
                }}
                required
                type="Number"
                id="standard-basic"
                variant="standard"
                label="Phone"
                // defaultValue={props.senderData[0].dial_code}
                value={props.receiverData[0].phone}
                disabled={props.editReceiver}
                error={cellNumberError}
                helperText={
                  cellNumberError ? "Please Enter Valid Cell Number" : ""
                }
                onChange={(e) => handleCellNumberChange(e)}
                sx={{
                  width: "100%",
                  "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  "input[type=number]": {
                    MozAppearance: "textfield",
                  },
                  textTransform: "uppercase",
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "15px" }}>
            <Col>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AddBusinessTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                required
                type="text"
                id="standard-basic"
                variant="standard"
                label="Address"
                disabled={props.editReceiver}
                value={props.receiverData[0].address}
                error={addressError}
                helperText={
                  addressError ? "Address Length (Maximium 45 Character)" : ""
                }
                onChange={(e) => handleAddressChange(e)}
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "15px" }}>
            <Col>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AddBusinessTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                id="standard-basic"
                variant="standard"
                label="Address 2"
                disabled={props.editReceiver}
                value={props.receiverData[0].address_2}
                error={addressError2}
                helperText={
                  addressError2 ? "Address Length (Maximium 45 Character)" : ""
                }
                onChange={(e) => handleAddress2Change(e)}
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "15px" }}>
            <Col xl="12" lg="12" md="12" sm="12" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AddBusinessTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                id="standard-basic"
                variant="standard"
                label="Address 3"
                disabled={props.editReceiver}
                value={props.receiverData[0].address_3}
                onChange={(e) =>
                  props.setReceiverData({
                    key: "address_3",
                    value: e.target.value.toUpperCase(),
                  })
                }
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: "15px" }}>
            <Col xl="4" lg="4" md="4" sm="4" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AddLocationAltTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                id="standard-basic"
                variant="standard"
                label="City *"
                value={props.receiverData[0].city}
                disabled={props.editReceiver}
                onChange={(e) =>
                  props.setReceiverData({
                    key: "city",
                    value: e.target.value.toUpperCase(),
                  })
                }
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
            <Col xl="4" lg="4" md="4" sm="4" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AddLocationAltTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                id="standard-basic"
                variant="standard"
                label="State *"
                value={props.receiverData[0].state}
                disabled={props.editReceiver}
                onChange={(e) =>
                  props.setReceiverData({
                    key: "state",
                    value: e.target.value.toUpperCase(),
                  })
                }
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
            <Col xl="4" lg="4" md="4" sm="4" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DialpadTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                // type="text"
                id="standard-basic"
                variant="standard"
                label="Postal Code/Zip code *"
                value={props.receiverData[0].postal_code}
                disabled={props.editReceiver}
                onChange={(e) =>
                  props.setReceiverData({
                    key: "postal_code",
                    value: e.target.value.toUpperCase(),
                  })
                }
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "15px" }}>
            <Col xl="4" lg="4" md="4" sm="4" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                // required
                type="email"
                id="standard-basic"
                variant="standard"
                label="Email"
                value={props.receiverData[0].email}
                disabled={props.editReceiver}
                error={emailError}
                helperText={emailError ? "Please Enter Valid Email" : ""}
                onChange={(e) => handleEmailChange(e)}
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
            <Col xl="4" lg="4" md="4" sm="4" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <NumbersTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                id="standard-basic"
                variant="standard"
                label="VAT/Tax ID"
                value={props.receiverData[0].vatId}
                // disabled={props.editReceiver}
                onChange={(e) =>
                  props.setReceiverData({
                    key: "vatId",
                    value: e.target.value.toUpperCase(),
                  })
                }
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                }}
              />
            </Col>
          </Row>

          {props.showButtonReceiver === true ? (
            ""
          ) : (
            <Row style={{ marginTop: "30px" }}>
              <Col xl="2" lg="2" md="2" sm="4" xs="6">
                <Button
                  disabled={
                    props.receiverData[0].company === "" ||
                    props.receiverData[0].country_id === 0 ||
                    props.receiverData[0].address === "" ||
                    props.receiverData[0].postal_code === "" ||
                    props.receiverData[0].city === "" ||
                    props.receiverData[0].state === "" ||
                    props.receiverData[0].phone === ""
                    // || props.receiverData[0].email === ""
                  }
                  style={{
                    marginLeft: "2%",
                    color: "black",
                    width: "80%",
                    backgroundColor: "#C5CBCF",
                    border: "1px solid white",
                  }}
                  onClick={handleSaveReceiver}
                >
                  Save Receiver
                </Button>
              </Col>
              <Col xl="8" lg="8" md="8" sm="4" xs="0"></Col>
              <Col xl="2" lg="2" md="2" sm="4" xs="6">
                <Button
                  disabled={
                    props.receiverData[0].company === "" ||
                    props.receiverData[0].country_id === 0 ||
                    props.receiverData[0].address === "" ||
                    props.receiverData[0].phone === ""
                    // || props.receiverData[0].email === ""
                  }
                  style={{
                    marginLeft: "2%",
                    color: "black",
                    width: "80%",
                    backgroundColor: "#C5CBCF",
                    border: "1px solid white",
                  }}
                  onClick={handleContinue}
                >
                  Continue
                </Button>
              </Col>
            </Row>
          )}
        </Card>
        {/* </div> */}
      </Container>
      {/* )} */}
    </>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getCountry: () => dispatch(getCountry()),
    getReceiver: () => dispatch(getReceiver()),
    setReceiverData: (data) => dispatch(setAddReceiverData(data)),
    setShowShipmentDetail: (data) => dispatch(setShowShipmentDetail(data)),
    addReceiver: (data, handleVisible, handleDangerVisible) =>
      dispatch(addReceiver(data, handleVisible, handleDangerVisible)),
    setEditableReceiver: (data) => dispatch(setEditableReceiver(data)),
    setShowButtonReceiver: (data) => dispatch(setShowButtonReceiver(data)),
    ownProps,
  };
};
const mapStateToProps = (state, ownProps) => ({
  receiverList: state.CargoReceiverReducer.receiverList,
  isFetchingReceiver: state.CargoReceiverReducer.isFetchingReceiver,
  isFetchingCountry: state.CargoCountryReducer.isFetchingCountry,
  countryList: state.CargoCountryReducer.countryList,
  receiverData: state.CargoCreateShipmentReducer.receiverData,
  senderData: state.CargoCreateShipmentReducer.senderData,
  editReceiver: state.CargoCreateShipmentReducer.editReceiver,
  showButtonReceiver: state.CargoCreateShipmentReducer.showButtonReceiver,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step2SelectReceiver);
